<template>
    <div class='manager_box' style='background:white;min-height:80vh; padding:20px;'>
         <el-tabs v-model="activeName" @tab-click="handleClick" style='background:white;min-height:60vh;'>
            <el-tab-pane label="账号管理" name="first">
                <el-form :model="form" :rules="rules" ref="ruleForm" class='form_establish'>
                    <el-form-item label="用户帐号" prop="username" :label-width="formLabelWidth" class='el_input_width currency_div'>
                        <el-input v-model="form.username" type="number" oninput="if(value.length>5)value=value.slice(0,11)" autocomplete="off" style='width:80%;' placeholder="请填写用户帐号"></el-input>
                    </el-form-item>
                    <el-form-item label="用户密码" prop="password" :label-width="formLabelWidth" class='el_input_width currency_div'>
                        <el-input v-model="form.password" autocomplete="off" style='width:80%;' placeholder="请填写用户密码"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号" prop="mobile" :label-width="formLabelWidth" class='el_input_width currency_div'>
                        <el-input v-model="form.mobile" type="number" oninput="if(value.length>5)value=value.slice(0,11)" autocomplete="off" style='width:80%;' placeholder="请填写手机号"></el-input>
                    </el-form-item>
                    <el-form-item label="性别" prop="gender" :label-width="formLabelWidth" class='el_input_width currency_div'>
                        <el-select v-model="form.gender" placeholder="请选择性别" style='width:80%;'>
                            <el-option
                                v-for="(item,index) in sex"
                                :key="index"
                                :label="item.label"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="真实姓名" prop="realname" :label-width="formLabelWidth" class='el_input_width currency_div'>
                        <el-input v-model="form.realname" placeholder="请输入真实姓名" autocomplete="off" style='width:80%;'></el-input>
                    </el-form-item>
                </el-form>
                <div class='button_div'>
                    <el-button type="primary" @click="account_creation" class='account_creation'>创建账号</el-button>
                </div>
            </el-tab-pane>
            <el-tab-pane label="账号列表" name="second">
                <el-table :data="tableData" style="width: 100%;background:white;min-height:50vh;" v-loading='loading'>
                    <el-table-column prop="realname" label="姓名" min-width="80"> 
                        <template slot-scope="scope">
                            <el-input  v-if='staff_id_data == scope.row.staff_id' v-model="form_list.realname" placeholder="请输入内容"></el-input>
                            <span  v-else>{{scope.row.realname}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="gender_name" label="性别" min-width="80"> 
                        <template slot-scope="scope">
                            <el-select v-if='staff_id_data == scope.row.staff_id' v-model="form_list.gender" placeholder="请选择性别" style='width:80%;'>
                                <el-option
                                    v-for="(item,index) in sex"
                                    :key="index"
                                    :label="item.label"
                                    :value="item.value"
                                ></el-option>
                            </el-select>
                            <span  v-else>{{scope.row.gender_name}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="username" label="账号" min-width="120"> </el-table-column>
                    <el-table-column prop="mobile" label="手机号" min-width="120"> 
                        <template slot-scope="scope">
                            <el-input type="number" oninput='if(value.length>0)value=value.slice(0,11)' v-if='staff_id_data == scope.row.staff_id' v-model="form_list.mobile" placeholder="请输入内容"></el-input>
                            <span  v-else>{{scope.row.mobile}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="create_time_str" label="创建时间" min-width="150"> </el-table-column>
                    <el-table-column label="操作" fixed="right" min-width="150"> 
                        <template slot-scope="scope">
                            <div v-if='staff_id_data == scope.row.staff_id'>
                                <el-button type="success" @click="preservation()">保存</el-button>
                            </div>
                            <div v-else>
                                <el-button @click="modify_information(scope.row)">修改</el-button>
                                <el-button type="warning" @click="restore_password(scope.row.staff_id)">密码重置</el-button>
                                <el-button type="danger" @click='delete_user(scope.row.staff_id)'>删除</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import { require } from "@/utils/http_request.js";
export default {
    data() {
        return {
            activeName: 'first',
            formLabelWidth: "120px",
            judge_button: false,
            loading: false,
            staff_id_data: '',

            form: {
                username: "",
                password: "",
                mobile: "",
                gender: "",
                realname: "",
            }, //表单数据
            form_list: {
                mobile: "",
                gender: "",
                realname: "",
            }, //表单数据
            rules: {
                username: [ { required: true, message: "请输入用户账号", trigger: "blur" }, { min: 1, max: 11, message: "长度在 1 到 11 个字符", trigger: "blur" } ],
                password: [{ required: true, message: "请输入密码", trigger: "blur" }],
                mobile: [
                    { required: true, message: "请输入手机号", trigger: "blur" },
                    { min: 1, max: 11, message: "请输入正确的手机号", trigger: "blur" }
                ],
                gender: [{ required: true, message: "请选择性别", trigger: "change" }],
                realname: [
                    { required: true, message: "请输入真实姓名", trigger: "blur" }
                ]
            },
            sex: [ {
                    label: "男",
                    value: 1
                }, {
                    label: "女",
                    value: 2
                }
            ],

            tableData: []
        }
    },
    methods: {
        handleClick(tab, event) {
            // console.log(tab.index);
            if(tab.index == 1){
                this.personnel_list()
            }
        },
        personnel_list() {
            this.loading = true
            require('post', '/lufish_hrm/v1/personnel_list/', {}).then(res=> {
                if(!res.code){
                    this.tableData = res.data
                }else{
                    this.$message.error(res.msg);
                }
                this.loading = false
            })
        },
        account_creation() {
            let form = this.form;
            for (let i in this.rules) {
                if (form[i] == "") {
                    this.$message.error("请检查数据格式");
                    return false;
                    break;
                }
            }
            require('post', '/lufish_hrm/v1/personnel/', {
                label_code: 'create',
                create_data: this.form
            }).then(res=> {
                if(!res.code){
                    this.$message({ message: res.msg, type: 'success' });
                    this.form = {
                        username: "",
                        password: "",
                        mobile: "",
                        gender: "",
                        realname: "",
                    }
                }else{
                    this.$message.error(res.msg);
                }
            })
        },
        // select_auth(e) {
        //     console.log(e)
        //     if(e != 'AUBJSMKKJ1'){
        //         console.log(111)
        //         this.department_authority = true
        //     }else {
        //         console.log(222)
        //         this.department_authority = false
        //     }
        // },
        modify_information(e) {
            this.staff_id_data = e.staff_id
            this.form_list = {
                mobile: e.mobile,
                gender: e.gender,
                realname: e.realname,
            }
            console.log('修改', e)
        },
        preservation() {
            console.log('内容', this.form_list)
            for(let i in this.form_list){
                if(this.form_list[i] == ''){
                    this.$message.error('请检测是否填写完整');
                    return false;
                    break;
                }else if((i == 'username' || i == 'mobile') && this.form_list[i].length != 11){
                    this.$message.error('填写有误');
                    return false;
                    break;
                }
            }
            require('post', '/lufish_hrm/v1/personnel/', {
                label_code: 'update',
                staff_id: this.staff_id_data,
                update_data: this.form_list
            }).then(res=> {
                if(!res.code){
                    this.$message({ message: res.msg, type: 'success' });
                    this.staff_id_data = ''
                    this.personnel_list()
                }else{
                    this.$message.error(res.msg);
                }
            })
        },
        restore_password(e) {
            console.log('还原密码', e)
            this.$confirm('确定还原密码吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                require('post', '/lufish_user/v1/lufish_restore_password/', {
                    staff_id: e
                }).then(res=> {
                    if(!res.code){
                        this.$message({ message: res.msg, type: 'success' });
                        this.personnel_list()
                    }else{
                        this.$message.error(res.msg);
                    }
                })
            }).catch(() => {});
        },
        delete_user(e) {
            console.log('删除', e)
            this.$confirm('确定删除该职员吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                require('post', '/lufish_hrm/v1/personnel/', {
                    label_code: 'delete',
                    staff_id: e
                }).then(res=> {
                    if(!res.code){
                        this.$message({ message: res.msg, type: 'success' });
                        this.personnel_list()
                    }else{
                        this.$message.error(res.msg);
                    }
                })
            }).catch(() => {});
        },
    }
}
</script>

<style>
.form_establish{
    display: flex;
    flex-wrap: wrap;
}
.currency_div{
    width: 50%;
}
.button_div{
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    padding: 20px;
    width: 100%;
}
.account_creation{
    width: 150px;
    line-height: 22px;
}
</style>


// WEBPACK FOOTER //
// src/personnel/personnel_creation.vue